import React, { useState, useRef, useEffect, useCallback } from "react";
import styles from "./styles.module.scss";

const STORAGE_KEY = "Brcom:AnnouncementDismissed";
const ANNOUNCEMENT_ID = "reajuste-tarifas-2026-05";

const AnnouncementModal = () => {
  const [visible, setVisible] = useState(false);
  const [reachedEnd, setReachedEnd] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    const dismissed = window.localStorage.getItem(STORAGE_KEY);
    if (dismissed !== ANNOUNCEMENT_ID) {
      setVisible(true);
    }
  }, []);

  useEffect(() => {
    if (!visible) return;
    const el = contentRef.current;
    if (!el) return;
    if (el.scrollHeight - el.clientHeight < 30) {
      setReachedEnd(true);
    }
  }, [visible]);

  const handleScroll = useCallback(() => {
    const el = contentRef.current;
    if (!el) return;
    const isAtBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 30;
    if (isAtBottom) {
      setReachedEnd(true);
    }
  }, []);

  const handleClose = () => {
    if (dontShowAgain) {
      window.localStorage.setItem(STORAGE_KEY, ANNOUNCEMENT_ID);
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2>Comunicado</h2>
        </div>
        <div
          className={styles.content}
          ref={contentRef}
          onScroll={handleScroll}
        >
          <h1 style={{ color: "#1a7f37", borderBottom: "3px solid #1a7f37", paddingBottom: 10, fontSize: "1.5em" }}>
            📢 Atualização de Tarifas
          </h1>

          <p>Prezados clientes,</p>

          <p>
            Sempre buscando manter a transparência e a qualidade dos serviços prestados, informamos que a partir do dia <strong>01 de maio de 2026</strong> as tarifas de todos os serviços serão reajustadas.
          </p>

          <p>
            O reajuste de <strong>4,2643%</strong>, com base no <strong>IPCA</strong> referente ao período de janeiro a dezembro de 2025, será aplicado a partir de <strong>01 de maio de 2026</strong>.
          </p>

          <p>
            Reforçamos que essa atualização acompanha os custos do setor, permitindo a continuidade de um serviço confiável, seguro e eficiente para todos.
          </p>

          <p>
            Permanecemos à disposição para esclarecer quaisquer dúvidas e apoiar no que for necessário.
          </p>

          {!reachedEnd && (
            <p style={{ textAlign: "center", color: "#999", marginTop: 20, fontSize: 13 }}>
              Role até o final para habilitar o botão de fechar
            </p>
          )}
        </div>
        <div className={styles.footer}>
          <label className={styles.checkbox}>
            <input
              type="checkbox"
              checked={dontShowAgain}
              onChange={() => setDontShowAgain(!dontShowAgain)}
            />
            <span>Não exibir novamente</span>
          </label>
          <button
            className={styles.closeButton}
            disabled={!reachedEnd}
            onClick={handleClose}
          >
            {reachedEnd ? "Entendi" : "Role até o final"}
          </button>
        </div>
      </div>
    </div>
  );
};

export { AnnouncementModal };
